"use strict";
$(function ($) {
  /* ドロワーメニュー */
  $('#js-hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('#js-drawer-menu').toggleClass('is-active');
    $('.header__inner').toggleClass('is-active'); // .header__innerにもis-activeを付け外し
    // $('.header').toggleClass('is-active'); // .header__innerにもis-activeを付け外し
    // $('.headerSp__top').toggleClass('is-active'); // .header__innerにもis-activeを付け外し

    // Text change between MENU and CLOSE
    if ($(this).hasClass('is-active')) {
      $(this).find('p').text('CLOSE');
    } else {
      $(this).find('p').text('MENU');
    }
  });

  // ハンバーガーメニュー内をクリックしたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click');
  });
});

/* ----- mega-menu ----- */
document.addEventListener("DOMContentLoaded", function () {
  const megaBtn = document.querySelector(".mega__btn");
  const megaItems = document.querySelector(".mega");
  const headerInner = document.querySelector(".header__inner");

  if (megaBtn && megaItems && headerInner) {
    megaBtn.addEventListener("click", function () {
      megaItems.classList.toggle("is-visible");
      headerInner.classList.toggle("is-visible");
    });
  }
});




/* ----- ヘッダー位置調整 ----- */
$(function () {
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
      $('.header').addClass('change');
    } else {
      $('.header').removeClass('change');
    }
  });
});

/* ----- headerSp megaMenu ----- */
$(".megaMenu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

/* ----- QAアコーディオン ----- */
$(".topQa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

/* ----- footerMenu ----- */
$(window).on("resize load", function() {
  if (window.innerWidth <= 767) {
    $(".footerMenu__btn").off("click").on("click", function() {
      $(this).next().slideToggle();
      $(this).toggleClass("is-active");
    });
  } else {
    $(".footerMenu__btn").off("click"); // 767px以上のときはクリックイベントを解除
  }
});



/* ----- fvースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".splide__fv", {
    // Splideの設定
    type: "fade", // フェード
    autoplay: true, // 自動再生
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false, // 矢印ボタンを非表示
    interval: 5000,
    speed: 2000,
    perPage: 1,
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  }).mount();
}


/* ----- caseスライダー ----- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".splide__case")) {
    // メインスライダー
    const main = new Splide(".splide__case", {
      autoplay: 'true',
      interval: 5000, // スライドの切り替えスピードを5秒に設定
      speed: 500,    // スライドの切り替え速度を.5秒に設定
      type: 'loop',
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
      fixedWidth : '34.5rem',
      focus      : 'center',   // 中央からスタート
      gap        : '2rem',     // スライド間隔を20px
      trimSpace: false,      // 見切れる部分を表示させる
      perMove: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      arrows: true,
      updateOnMove: true, // is-activeクラスを移動前に更新する
      padding    : { left: '50%', right: '50%' },  // 左右に見切れるスペースを確保
      breakpoints: {
        768: {
          gap    : '1.5rem',     // モバイルのスライド間隔
          padding: { left: '20%', right: '20%' },  // モバイルでの余白調整
          fixedWidth : '30rem',
        },
      }
    }).mount();
  }
});


/* ----- columnスライダー ----- */
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".splide__column")) {
    // メインスライダー
    const main = new Splide(".splide__column", {
      type: 'loop',
      speed: 500,    // スライドの切り替え速度を.5秒に設定
      rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
      fixedWidth : '34.5rem',
      focus      : 'center',   // 中央からスタート
      gap        : '2.4rem',     // スライド間隔を20px
      trimSpace: false,      // 見切れる部分を表示させる
      perMove: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      arrows: true,
      updateOnMove: true, // is-activeクラスを移動前に更新する
      padding    : { left: '50%', right: '50%' },  // 左右に見切れるスペースを確保
      breakpoints: {
        768: {
          gap    : '1.5rem',     // モバイルのスライド間隔
          padding: { left: '20%', right: '20%' },  // モバイルでの余白調整
          fixedWidth : '30rem',
        },
      }
    }).mount();
  }
});


/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;
// スマホサイズの時の追加オフセット（必要に応じて調整）
const mobileOffset = -100; // 50px 追加オフセット
// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};
// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}

/* ----- フェードイン ----- */
window.addEventListener('scroll', function(){
  // スクロール量を取得
  const scroll = window.scrollY;
  // 画面の高さを取得
  const windowHeight = window.innerHeight;
  // すべての.boxを取得
  const boxes = document.querySelectorAll('.fade');

  boxes.forEach(function(box) {
    // boxまでの高さを取得
    const distanceToBox = box.offsetTop;
    // 下記条件が成り立つときだけboxにis-activeクラスを付与する
    if(scroll + windowHeight > distanceToBox) {
      box.classList.add('is-active');
    }
  });
});



/* ----- インスタプラグイン hoverアクション ----- */
document.addEventListener("DOMContentLoaded", function() {
  const sbiItems = document.querySelectorAll('.sbi_item');

  sbiItems.forEach(item => {
    const textContainer = document.createElement('div');
    textContainer.classList.add('topInstagram__text');
    textContainer.innerHTML = '詳細をチェック<br><span>Instagram</span>';

    item.appendChild(textContainer);
  });
});
